import React from 'react';
import {Button, Form, Input} from 'antd';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import styled from '@emotion/styled';

export const RotatorTagInputAndPreview = () => {
    const history = useHistory();
    const { type, tagId, device } = useParams<{type?: string, tagId?: string, device?: string}>();
    let currentRotatorTag = tagId;

    const onPreviewClick = () => {
        const newLocation = `/demo/preview/${type}/${currentRotatorTag}${device ? `/${device}` : ""}`;
        history.push(newLocation);
    };

    const updateCurrentTag = (changedValues) => {
        currentRotatorTag = encodeURIComponent(changedValues.placementTag);
    }

    return <RotatorTagInputAndPreviewContainer>
        <Form
            name="preview_placement_tag"
            layout="inline"
            onSubmitCapture={onPreviewClick}
            onValuesChange={updateCurrentTag}
            initialValues={{
                placementTag: tagId ? decodeURIComponent(tagId) : ''
            }}
        >
            <Form.Item style={previewInput} name="placementTag">
                <Input style={previewText} />
            </Form.Item>
            <Form.Item style={previewButton}>
                <Button style={previewButton} type="primary" htmlType="submit">
                    Preview
                </Button>
            </Form.Item>
        </Form>
    </RotatorTagInputAndPreviewContainer>;
};

const previewButton = {
    height: "32px",
    width: "92px",
    backgroundColor: "#418FFF",
    fontFamily: "proximanova-regular",
    fontSize: "14px",
    letterSpacing: "0",
    lineHeight: "23px",
    display: "flex",
    paddingRight: "25px",
    borderRadius: "0px 4px 4px 0px",
};

const previewInput = {
    height: "32px",
    width: "290px",
    backgroundColor: "#FFFFFF",
    display: "flex",
    marginRight: "0px",
}

const previewText = {
    fontSize: "12px",
    height: "32px",
    borderRadius: "4px 0px 0px 4px",
    fontFamily: "proximanova-regular"
}

const RotatorTagInputAndPreviewContainer = styled.div`
    padding-button: 16.5px;
    flex-direction: row;
    display: flex;
    align-items: center;
    width: 430px;

`;
